import $ from 'jquery';
import MicroModal from 'micromodal';

export default {
  init: () => {
    MicroModal.init();

    $('#modal-share-story .modal-close-btn').on('click', (e) => {
      e.preventDefault();
      MicroModal.close('modal-share-story');
      return false;
    });

    $('#shareMyStory').on('click', (e) => {
      e.preventDefault();

      MicroModal.show('modal-share-story',{
        disableFocus: true,
        onShow: function() {
        },
        onClose: function() {
        }
      });

      return false;
    });
  },
};
